<template>
  <div>
    <CadPolicy v-if="company == 'Lancaster Canada'"/>
    <UsPolicy v-if="company == 'Lancaster US'"/>
    <EjwPolicy v-if="company == 'EJ Welch'"/>
    <CheneyPolicy v-if="company == 'Cheney'"/>
    <MeritSupplyPolicy v-if="company == 'Merit Supply'"/>
  </div>
</template>

<script>
  import CadPolicy from './CadPolicy.vue'
  import UsPolicy from './UsPolicy.vue'
  import EjwPolicy from './EjwPolicy.vue'
  import CheneyPolicy from './CheneyPolicy.vue'
  import MeritSupplyPolicy from './MeritSupplyPolicy.vue'
  
  export default {
    components:{
      CadPolicy,
      UsPolicy,
      EjwPolicy,
      CheneyPolicy,
      MeritSupplyPolicy
    },
    computed:{
      company(){return this.$store.getters.sessionCompany}
    }
  }
</script>